import Resolver from "@/api/resolver";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { towerNamespace } from "@/store/modules/tower";
import { TowerAction } from "@/store/modules/tower/actions";
import { TOWER_POSTOPREVIEW_SAVE } from "@/store/modules/tower/mutation_types";
import _ from "lodash";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { newWindowEventListeners, TIME_ONLY_FORMAT } from "../shared/util";

@Component({
  components: { }
})
export default class PostOpReview extends Vue {
  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("vars", patientNamespace)
  vars!: any;

  showTasks = true;
  noEdit = false;
  saving = false;
  closing = false;

  @Action(TOWER_POSTOPREVIEW_SAVE, towerNamespace)
  TOWER_POSTOPREVIEW_SAVE!: Function;

  // editing = false;
  waiting = false;

  toggleAllTasks() {
    this.showTasks = !this.showTasks;
  }
  
  get postOpReview() {
    return _.cloneDeep(this.current.body.postOpReview);
  }
  get caseReviewRules() {
    return JSON.parse(this.vars.logicRules.RuleCaseReview);
  }

  // If false, not part of the study
  get treatmentPatient(): boolean {
    return this.current.census.treatment === 1;
  }

  get treatmentText() {
    const census = this.current.census;
    if (census.age > 0 && census.age < 18) {
      return "Patient Less Than 18 Years Old";
    } else if (this.treatmentPatient) {
      return "Treatment Patient: Contact Providers";
    } else {
      return "Control Patient: Do Not Contact Providers";
    }
  }

  mounted() {
    const ref = this;
    newWindowEventListeners(ref, "PostOpReview", this.$route.params.room);

    // Initializing this based on the status, so when you first bring up the form all of the tasks are available
    this.showTasks = (this.current.body && this.current.body.postOpReview && this.current.body.postOpReview.Status > 1) ? false : true;
  }

  @Action("hidePopup", navigationNamespace)
  hidePopup!: Function;

  async save(close: boolean = true) {
    this.waiting = true;
    this.saving = true;
    this.closing = close;
    try {
      const roomSys = this.$route.params.room;
      const response = await this.TOWER_POSTOPREVIEW_SAVE({
        item: this.postOpReview,
        action: TowerAction.SAVE_POSTOP_REVIEW,
        roomSys
      });

      if (close && response.concurrencyMessage.length === 0) {
        this.hidePopup();
      }
      else if (response.concurrencyMessage.length > 0) {
        alert(response.concurrencyMessage);
      }
      else {
        // The sequence (concurrency ID) is returned  (possibly return entire object and not just concurrency...)
        this.postOpReview.Sequence = response.newSequence;
      }

      this.saving = false;
    } finally {
      this.waiting = false;
    }
  }  
}
